import OwsOptionsBase from '../store/schema/OwsOptionsBase';
import OwsOptionsStore from '../store/schema/OwsOptionsStore';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';
import { action } from 'satcheljs/lib/legacy';

export default action('setFeatureSettings')(function setFeatureSettings(
    store: OwsOptionsStore,
    feature: OwsOptionsFeatureType,
    value: OwsOptionsBase
) {
    store.options[feature] = value;
});
